import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CardTabsComponent } from '../components/cardtabs/cardtabs.component';
import { ImageListComponent } from '../components/imagelist/imagelist.component';
import { RestrictedComponent } from '../restricted/restricted.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { ReportingComponent } from '../reporting/reporting.component';
import { SetupComponent } from '../setup/setup.component';

import { DynamicFormModule } from '../_dynamic_form/dynamic-form.module';

import { ProductsComponent } from '../products/products.component';
import { ProductDetailsComponent } from '../products/single-product/details/product-details.component';
import { ProductImagesComponent } from '../products/single-product/images/product-images.component';
import { ProductNutritionComponent } from '../products/single-product/nutrition/product-nutrition.component';
import { ProductIngredientsComponent } from 'app/products/single-product/ingredients/product-ingredients.component';

import { ProductsV2Component } from '../products-v2/products-v2.component';
import { ProductDetailsV2Component } from '../products-v2/single-product/details/product-details.component';
import { ProductImagesV2Component } from '../products-v2/single-product/images/product-images.component';
import { ProductNutritionV2Component } from '../products-v2/single-product/nutrition/product-nutrition.component';
import { ProductIngredientsV2Component } from 'app/products-v2/single-product/ingredients/product-ingredients.component';

import { CategoriesComponent } from '../categories/categories.component';
import { KioskCategoriesComponent } from '../kiosk-categories/kiosk-categories.component';
import { FoodToGoCategoriesComponent } from '../food-to-go-categories/food-to-go-categories.component';
import { UOwnerUsersComponent } from 'app/u-owner-users/u-owner-users.component';
import { UGroupUsersComponent } from 'app/u-group-users/u-group-users.component';
import { UConsoleUsersComponent } from 'app/u-console-users/u-console-users.component';
import { OrderGroupsComponent } from 'app/order-groups/order-groups.component';
import { StoresComponent } from 'app/stores/stores.component';
import { StoreDetailsComponent } from 'app/indi-store/details/store-details.component';
import { StoreOpeningTimesComponent } from 'app/indi-store/opening-times/store-opening-times.component';
import { StoreLocationComponent } from 'app/indi-store/location/store-location.component';
import { StoreMediaComponent } from 'app/indi-store/media/store-media.component';
import { StorePaymentSetupComponent } from 'app/indi-store/payment-setup/store-payment-setup.component';
import { StorePosSetupComponent } from 'app/indi-store/pos-setup/store-pos-setup.component';
import { StoreServicesComponent } from 'app/indi-store/services/store-services.component';
import { StoreSettingsComponent } from 'app/indi-store/settings/store-settings.component';
import { CustomBuildersComponent } from '../custom-builders/custom-builders.component';
import { OrdersComponent } from '../orders/orders.component';
import { IndiOrderComponent } from '../orders/indi-order/indi-order.component';
import { CustomersComponent } from '../customers/customers.component';
import { ImageBankComponent } from '../image-bank/image-bank.component';
import { PushNotificationsComponent } from '../push-notifications/push-notifications.component';
import { SelectStoreComponent } from './select-store/select-store.component';
import { ProductDialogComponent } from './dialogs/product-detail/product-dialog.component';
import { ProductDetailsFormComponent } from './forms/products/product-details-form/product-details-form.component';
import { ProductWarehouseFormComponent } from './forms/products/product-warehouse-form/product-warehouse-form.component';
import { ProductMediaFormComponent } from './forms/products/product-media-form/product-media-form.component';
import { ProductCategoriesFormComponent } from './forms/products/product-categories-form/product-categories-form.component';
import { ProductFoodToGoCategoriesFormComponent } from './forms/products/product-food-to-go-categories/product-food-to-go-categories-form.component';
import { ProductNutritionFormComponent } from './forms/products/product-nutrition-form/product-nutrition-form.component';
import { ProductIngredientsFormComponent } from './forms/products/product-ingredients-form/product-ingredients-form.component';

/* pipes */
import { RoleNamePipe } from '../_pipes/role.pipe';
import { DayOfWeekPipe } from '../_pipes/day-of-week.pipe';
import { KeysPipe } from '../_pipes/keyvalue.pipe';
import { CamelCaseToSpacePipe } from '../_pipes/camelcase.pipe';

import { ObjectFilterPipe } from '../_pipes/object-filter.pipe';

/* PrimeNg */
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { LightboxModule } from 'ngx-lightbox';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { SidebarModule } from 'primeng/sidebar';
import { CheckboxModule } from 'primeng/checkbox';
import { FieldsetModule } from 'primeng/fieldset';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';

import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AccordionModule } from 'primeng/accordion';
import { TreeModule } from 'primeng/tree';
import { MultiSelectModule } from 'primeng/multiselect';
import { SingleCustomBuilderDetailsComponent } from '../custom-builders/single-builder/single-builder-details/single-builder-details.component';
import { SingleCustomBuilderImagesComponent } from '../custom-builders/single-builder/single-builder-images/single-builder-images.component';
import { SingleCustomBuilderStageComponent } from '../custom-builders/single-builder/single-builder-stages/single-builder-stage.component';
import { SingleOrderGroupDetailsComponent } from '../order-groups/single-order-group/single-order-group-details/single-order-group-details.component';
import { SingleOrderGroupSlotsComponent } from '../order-groups/single-order-group/single-order-group-slots/single-order-group-slots.component';
import { AgmCoreModule } from '@agm/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { StoreDeliveryTimesComponent } from 'app/indi-store/delivery-times/delivery-times.component';
import { StoreKiosksComponent } from 'app/indi-store/kiosks/kiosks.component';

import { AgGridModule } from 'ag-grid-angular';

import { LinkRendererComponent } from '../components/ag-grid/link-renderer.component';
import { ImageTableComponent } from '../components/ag-grid/image-table.component';
import { ProductDetailsLinkComponent } from '../components/ag-grid/product-details-link.component';
import { ImageLinksComponent } from '../components/ag-grid/image-links.component';

import { EditorModule } from 'primeng/editor';

import { NgxJsonViewerModule } from 'ngx-json-viewer';

@NgModule({
  imports: [
    InputTextareaModule,
    InputTextModule,
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    PanelModule,
    DialogModule,
    TabViewModule,
    ConfirmDialogModule,
    CalendarModule,
    ToolbarModule,
    FileUploadModule,
    LightboxModule,
    TableModule,
    PaginatorModule,
    SidebarModule,
    CheckboxModule,
    FieldsetModule,
    RadioButtonModule,
    DropdownModule,
    NgxChartsModule,
    AccordionModule,
    DynamicFormModule,
    TreeModule,
    NgxJsonViewerModule,
    MultiSelectModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAT0bVot4ypYojQ6tlL2HnFPl9v7ZjdDLs',
      libraries: ['places'],
    }),
    GooglePlaceModule,
    EditorModule,
    AgGridModule.withComponents([]),
  ],
  declarations: [
    CardTabsComponent,
    ImageListComponent,
    RestrictedComponent,
    DashboardComponent,
    UserProfileComponent,
    ReportingComponent,
    SetupComponent,
    RoleNamePipe,
    KeysPipe,
    CamelCaseToSpacePipe,
    ObjectFilterPipe,
    DayOfWeekPipe,
    ProductsComponent,
    ProductDetailsComponent,
    ProductImagesComponent,
    ProductNutritionComponent,
    ProductIngredientsComponent,
    ProductDetailsV2Component,
    ProductImagesV2Component,
    ProductNutritionV2Component,
    ProductIngredientsV2Component,
    ProductsV2Component,
    CategoriesComponent,
    KioskCategoriesComponent,
    FoodToGoCategoriesComponent,
    UOwnerUsersComponent,
    UGroupUsersComponent,
    UConsoleUsersComponent,
    OrderGroupsComponent,
    SingleOrderGroupDetailsComponent,
    SingleOrderGroupSlotsComponent,
    StoresComponent,
    StoreDetailsComponent,
    StoreOpeningTimesComponent,
    StoreLocationComponent,
    StoreMediaComponent,
    StorePaymentSetupComponent,
    StorePosSetupComponent,
    StoreServicesComponent,
    StoreSettingsComponent,
    StoreDeliveryTimesComponent,
    StoreKiosksComponent,
    CustomBuildersComponent,
    SingleCustomBuilderDetailsComponent,
    SingleCustomBuilderStageComponent,
    SingleCustomBuilderImagesComponent,
    OrdersComponent,
    IndiOrderComponent,
    CustomersComponent,
    ImageBankComponent,
    PushNotificationsComponent,
    SelectStoreComponent,
    LinkRendererComponent,
    ImageTableComponent,
    ProductDetailsLinkComponent,
    ImageLinksComponent,
    ProductDialogComponent,
    ProductDetailsFormComponent,
    ProductWarehouseFormComponent,
    ProductMediaFormComponent,
    ProductCategoriesFormComponent,
    ProductFoodToGoCategoriesFormComponent,
    ProductNutritionFormComponent,
    ProductIngredientsFormComponent,
  ],
  exports: [
    CardTabsComponent,
    ImageListComponent,
    RestrictedComponent,
    DashboardComponent,
    UserProfileComponent,
    ReportingComponent,
    SetupComponent,
    RoleNamePipe,
    KeysPipe,
    CamelCaseToSpacePipe,
    ObjectFilterPipe,
    DayOfWeekPipe,
    ProductsComponent,
    ProductDetailsComponent,
    ProductImagesComponent,
    ProductNutritionComponent,
    ProductIngredientsComponent,
    ProductDetailsV2Component,
    ProductImagesV2Component,
    ProductNutritionV2Component,
    ProductIngredientsV2Component,
    ProductsV2Component,
    CategoriesComponent,
    KioskCategoriesComponent,
    FoodToGoCategoriesComponent,
    UOwnerUsersComponent,
    UGroupUsersComponent,
    OrderGroupsComponent,
    SingleOrderGroupDetailsComponent,
    SingleOrderGroupSlotsComponent,
    StoresComponent,
    StoreDetailsComponent,
    StoreOpeningTimesComponent,
    StoreLocationComponent,
    StoreMediaComponent,
    StorePaymentSetupComponent,
    StorePosSetupComponent,
    StoreServicesComponent,
    StoreSettingsComponent,
    StoreDeliveryTimesComponent,
    StoreKiosksComponent,
    CustomBuildersComponent,
    SingleCustomBuilderDetailsComponent,
    SingleCustomBuilderStageComponent,
    SingleCustomBuilderImagesComponent,
    OrdersComponent,
    IndiOrderComponent,
    CustomersComponent,
    ImageBankComponent,
    PushNotificationsComponent,
    SelectStoreComponent,
    ProductDialogComponent,
    ProductDetailsFormComponent,
    ProductWarehouseFormComponent,
    ProductMediaFormComponent,
    ProductCategoriesFormComponent,
    ProductFoodToGoCategoriesFormComponent,
    ProductNutritionFormComponent,
    ProductIngredientsFormComponent,
  ],
  entryComponents: [LinkRendererComponent, ImageTableComponent, ProductDetailsLinkComponent, ImageLinksComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/components/shared.module.ts